import React from 'react'
import './App.css'
import 'normalize.css'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Header from './Header'
import LinkBloks from './LinkBlocks'
import Footer from './Footer'
import Form from './Form'
import T1 from '../page/T1'
import T2 from '../page/T2'
import T4 from '../page/T4'
import LinkBlocks_second from './LinkBlocks_second'
import T3_1 from '../page/T3_1'
import T3_2 from '../page/T3_2'
import T3_3 from '../page/T3_3'
import About from './about'
import Contact from './contact'
import Portfolio from '../page/portfolio'


class App extends React.Component {
  render() {
    return (
      <Router>
        <React.Fragment>
          <Header />
          <main>
            <Switch>
              <Route path="/create-tracks/coke" component={T3_1} />
              <Route path="/create-tracks/compositions" component={T3_2} />
              <Route path="/create-tracks/florariums" component={T3_3} />
              <Route path="/create-tracks" component={LinkBlocks_second} />
              <Route path="/order" component={Form} />
              <Route path="/vertical-landscaping" component={T1} />
              <Route path="/decorating-interiors" component={T2} />
              <Route path="/floristics" component={T4} />
              <Route path="/about" component={About} />
              <Route path="/contact" component={Contact} />
              <Route path="/portfolio" component={Portfolio} />
              <Route path="/" component={LinkBloks} />
            </Switch>
          </main>
          <Footer />
        </React.Fragment>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.jsx